// extracted by mini-css-extract-plugin
export var scrollArea = "_nu-0";